// extracted by mini-css-extract-plugin
export var actionButton = "_7i-0";
export var attachmentLine = "_7i-1";
export var fileInput = "_7i-2";
export var fileUploadWrapper = "_7i-4";
export var footer = "_7i-3";
export var modalContent = "_7i-5";
export var paperclip = "_7i-6";
export var quillEditor = "_7i-7";